
window.network = {
    blockchain:'eos',
    protocol:'https',
    host:'node.eosflare.io',
    port:'',
    chainId:'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906'
};




// WEBPACK FOOTER //
// ./src/HelperTrx.js